(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nivokid-product"]) return;
  try {
    
 document.querySelectorAll('[data-nivokid-selector]').forEach(function(select) {
  select.addEventListener('change', function() {
   const option = select.options[select.selectedIndex];
   const price = document.getElementById(select.dataset.priceTarget);
   const button = select.form.querySelector('[data-nivokid-add]');
   price.textContent = option.dataset.price;
   const photo = document.getElementById('nk-product-photo');
   if (photo && option.dataset.photo) { photo.src = option.dataset.photo; photo.removeAttribute('srcset'); photo.alt = option.dataset.photoAlt; }
   button.disabled = option.dataset.available !== 'true';
   button.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
   const url = new URL(window.location.href);
   url.searchParams.set('variant', select.value);
   window.history.replaceState({}, '', url);
  });
 });

  } catch(e) { console.error(e); }
})();
})();
